import React, { useState, useMemo } from "react";

export const useShowHook = () => {
  // 左侧slidelist栏是否显示loading
  const [isShowSlidesLoading, setIsShowSlidesLoading] = useState(true);
  // 是否显示左侧slideList栏
  const [isShowSlideList, setIsShowSlideList] = useState(true);
  // 是否显示ai栏
  const [isShowAi, setIsShowAi] = useState(false);
  // 是否显示右侧data栏
  const [isShowData, setIsShowData] = useState(false);
  // 是否显示右侧编辑创建note栏
  const [isShowActionNote, setIsShowActionNote] = useState(-1);
  // 是否显示拨片图
  const [isShowSlideOverview, setIsShowSlideOverview] = useState(false);
  // Viewer左下角的RotationCircle圆圈
  const [isShowRotationCircle, setIsShowRotationCircle] = useState(false);

  const dataBoxClasss = useMemo(() => {
    if(!isShowAi && !isShowData){
      return "hide-all"
    };
    if(isShowAi && isShowData){
      return "show-all"
    }

    if(isShowData && !isShowAi) {
      return "show-data"
    };

    if(!isShowData && isShowAi) {
      return "show-ai"
    };
    
  }, [isShowAi, isShowData]);

  const dataClass = useMemo(() => {
    if(["show-data", 'show-all'].includes(dataBoxClasss)){
      return 'data-l-0'
    };
    return 'data-l-72'
  }, [dataBoxClasss]);

  const aiClass = useMemo(() => {
    
    if(["show-data", 'show-all'].includes(dataBoxClasss)) {
      return "ai-l-72"
    };
    return 'ai-l-0'
  }, [dataBoxClasss])

  return {
    dataBoxClasss, aiClass, dataClass,
    isShowSlidesLoading, isShowSlideList, isShowAi, isShowData, isShowActionNote, isShowSlideOverview, isShowRotationCircle,
    setIsShowSlidesLoading, setIsShowSlideList, setIsShowAi, setIsShowData, setIsShowActionNote, setIsShowSlideOverview, setIsShowRotationCircle
  }
}